"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapToQBMatchup = void 0;
function mapToQBMatchup(response, player, team, eventId) {
    const playerGrade = {
        rank: response.playerRank,
        totalRank: response.playerRankTotal,
        grade: -1,
        facet: response.facet,
    };
    const teamGrade = {
        rank: response.overallDefendingRank,
        totalRank: response.overallDefendingRankTotal,
        grade: -1,
        facet: response.defendingFacet,
    };
    const result = {
        player: player,
        playerGrade: playerGrade,
        defendingTeam: team,
        defendingTeamGrade: teamGrade,
        overallMatchupScore: response.overallMatchupScore,
        eventId: eventId,
        matchups: response.matchups.map((matchup) => {
            const matchupResult = {
                offensiveUnit: matchup.offensiveUnit,
                offensiveRank: matchup.offensiveRank,
                offensiveRankTotal: matchup.offensiveRankTotal,
                defendingUnit: matchup.defendingUnit,
                defendingRank: matchup.defendingRank,
                defendingRankTotal: matchup.defendingRankTotal,
                matchupScore: matchup.matchupScore,
            };
            return matchupResult;
        }),
    };
    return result;
}
exports.mapToQBMatchup = mapToQBMatchup;
//# sourceMappingURL=qb_matchups_request.js.map